import { connect } from "react-redux";
import { ItemUpdateProgress } from "../shared/ItemUpdateProgress";
import { downloadInboundReceipt, downloadOutboundReceipt, getItemUpdateTask } from "../../app/store/actions/imsWarehouseStaffActions";

const WHItemUpdateProgress = (props) => (
    <ItemUpdateProgress
        {...props}
        historyPath="/ims/warehouse-staff/item-updates"
        homePath="/ims/warehouse-staff"
        inboundsPath="/ims/warehouse-staff/inbounds"
    />
);

export default connect(null, { getItemUpdateTask, downloadOutboundReceipt, downloadInboundReceipt })(WHItemUpdateProgress);
